export default __webpack_public_path__ + "static/media/sl.633cfaef.png";